import React, { useState } from 'react';
import { Calendar } from './ui/calendar';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Clock, CheckCircle2 } from 'lucide-react';
import { availableSlots } from '../mock';

export const BookingCalendar = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [bookingConfirmed, setBookingConfirmed] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });

  const getAvailableTimesForDate = (date) => {
    if (!date) return [];
    const dateStr = date.toISOString().split('T')[0];
    return availableSlots
      .filter(slot => slot.date === dateStr)
      .map(slot => slot.time);
  };

  const availableTimes = getAvailableTimesForDate(selectedDate);

  const handleBooking = (e) => {
    e.preventDefault();
    if (selectedDate && selectedTime && formData.name && formData.email) {
      // Mock booking - will integrate with backend later
      setBookingConfirmed(true);
      setTimeout(() => {
        setBookingConfirmed(false);
        setSelectedDate(null);
        setSelectedTime(null);
        setFormData({ name: '', email: '', phone: '' });
      }, 3000);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="booking-section" id="booking">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">Book Your Free Consultation</h2>
          <p className="body-large">Start your transformation journey today. Schedule a free session with Vikas Vaid.</p>
        </div>

        {bookingConfirmed ? (
          <Card className="booking-confirmation">
            <CardContent className="confirmation-content">
              <CheckCircle2 className="confirmation-icon" />
              <h3 className="heading-2">Booking Confirmed!</h3>
              <p className="body-medium">Your free consultation has been scheduled. Check your email for confirmation details.</p>
            </CardContent>
          </Card>
        ) : (
          <div className="booking-grid">
            <Card className="calendar-card">
              <CardHeader>
                <CardTitle>Select a Date</CardTitle>
                <CardDescription>Choose your preferred date for the consultation</CardDescription>
              </CardHeader>
              <CardContent>
                <Calendar
                  mode="single"
                  selected={selectedDate}
                  onSelect={setSelectedDate}
                  disabled={(date) => date < new Date() || date > new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}
                  className="booking-calendar"
                />
              </CardContent>
            </Card>

            <Card className="booking-form-card">
              <CardHeader>
                <CardTitle>Complete Your Booking</CardTitle>
                <CardDescription>Fill in your details and select a time slot</CardDescription>
              </CardHeader>
              <CardContent>
                <form onSubmit={handleBooking} className="booking-form">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Enter your name"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="your.email@example.com"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+1 (555) 000-0000"
                    />
                  </div>

                  {selectedDate && availableTimes.length > 0 && (
                    <div className="form-group">
                      <label>Available Time Slots *</label>
                      <div className="time-slots">
                        {availableTimes.map((time) => (
                          <button
                            key={time}
                            type="button"
                            className={`time-slot ${selectedTime === time ? 'selected' : ''}`}
                            onClick={() => setSelectedTime(time)}
                          >
                            <Clock size={16} />
                            {time}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {selectedDate && availableTimes.length === 0 && (
                    <p className="no-slots">No available slots for this date. Please select another date.</p>
                  )}

                  <Button
                    type="submit"
                    className="btn-primary"
                    disabled={!selectedDate || !selectedTime || !formData.name || !formData.email}
                  >
                    Confirm Free Consultation
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        )}
      </div>
    </div>
  );
};
